import { SettingUrls } from 'constants/SettingsUrls';
import { SettingKey } from 'data/ppoints/constants';
import useSettings from 'hooks/useSettings';
import { IntegrationModeSetting } from 'models/ppoints/settings/SettingsToEcom';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useShopifySubscription from 'hooks/billing/useShopifySubscription';
import { useNavigate } from 'react-router';

export const IntegrationSettingsBanner: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { settings, fetching: settingsFetching } = useSettings<IntegrationModeSetting>(SettingKey.integration_mode);
    const { currentSubscription, isLoading: subscriptionLoading } = useShopifySubscription();

    if (settingsFetching || subscriptionLoading || !currentSubscription || settings) return null;

    return (
        <s-banner heading={t('INTEGRATION_SETTINGS_BANNER.HEADING')} tone="warning">
            <div className="flex flex-col gap-2">
                <span>{t('INTEGRATION_SETTINGS_BANNER.DESCRIPTION')}</span>
                <div className="flex">
                    <s-button onClick={() => navigate(SettingUrls.integrationMode)}>
                        {t('INTEGRATION_SETTINGS_BANNER.BUTTON')}
                    </s-button>
                </div>
            </div>
        </s-banner>
    );
};
